export const COURSES = [
  {
    id: "niif-pymes",
    title: "NIIF para PYMES 2026",
    category: "NIIF/IFRS",
    level: "Intermedio",
    duration: "6 semanas",
    modality: "100% en vivo + grabaciones",
    price: 690000,
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80&w=1200",
    description: "Actualización completa en la Sección de PYMES con casos de reconocimiento, medición y revelación aplicados a empresas reales.",
    syllabus: [
      "Marco conceptual y alcance de las NIIF para PYMES",
      "Reconocimiento de ingresos y cuentas por cobrar",
      "Propiedad, planta y equipo: deterioro y vida útil",
      "Instrumentos financieros simplificados",
      "Caso integral: conversión de estados financieros",
    ],
  },
  {
    id: "renta-personas",
    title: "Declaración de Renta Personas Naturales",
    category: "Tributación",
    level: "Práctico",
    duration: "4 semanas",
    modality: "100% en vivo + grabaciones",
    price: 590000,
    image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&q=80&w=1200",
    description: "Paso a paso para depurar la cédula general y de dividendos, optimizar beneficios tributarios y evitar sanciones.",
    syllabus: [
      "Depuración de ingresos y rentas exentas",
      "Cédulas: general, pensiones y dividendos",
      "Deducciones y rentas exentas del 25%",
      "Liquidación en el formulario 210",
    ],
  },
  {
    id: "auditoria-forense",
    title: "Auditoría Forense y Control Interno",
    category: "Auditoría",
    level: "Avanzado",
    duration: "5 semanas",
    modality: "100% en vivo + grabaciones",
    price: 740000,
    image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&q=80&w=1200",
    description: "Técnicas de detección de fraude, trazabilidad de transacciones y diseño de controles que sí funcionan.",
    syllabus: [
      "Tipologías de fraude corporativo",
      "Red flags y analítica de datos",
      "Diseño de matriz de control interno",
      "Informe forense y cadena de custodia",
      "Taller: caso real de desfalco empresarial",
    ],
  },
  {
    id: "excel-financiero",
    title: "Excel Financiero Avanzado para Contadores",
    category: "Herramientas Digitales",
    level: "Todos los niveles",
    duration: "3 semanas",
    modality: "100% en vivo + grabaciones",
    price: 450000,
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=1200",
    description: "De tablas dinámicas a modelos financieros automatizados: el Excel que un contador senior realmente usa a diario.",
    syllabus: [
      "Tablas dinámicas y Power Query aplicadas a contabilidad",
      "Funciones financieras: VNA, TIR, amortización",
      "Conciliaciones bancarias automatizadas",
      "Dashboard contable listo para dirección",
    ],
  },
  {
    id: "power-bi",
    title: "Power BI para Reportes Contables y NIIF",
    category: "Herramientas Digitales",
    level: "Intermedio",
    duration: "4 semanas",
    modality: "100% en vivo + grabaciones",
    price: 620000,
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=1200",
    description: "Conecta tu ERP, modela el balance y el P&L, y entrega reportes ejecutivos que impresionan a la gerencia.",
    syllabus: [
      "Conexión a fuentes contables y modelado de datos",
      "DAX esencial para indicadores financieros",
      "Balance, P&L y flujo de caja interactivos",
      "Publicación y automatización de reportes",
    ],
  },
  {
    id: "nomina-electronica",
    title: "Nómina Electrónica y Prestaciones Sociales",
    category: "Tributación",
    level: "Práctico",
    duration: "3 semanas",
    modality: "100% en vivo + grabaciones",
    price: 480000,
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=1200",
    description: "Liquidación de nómina, prestaciones, aportes y transmisión de documentos soporte ante la DIAN sin errores.",
    syllabus: [
      "Liquidación de devengados y deducciones",
      "Prestaciones sociales y provisiones",
      "Documento soporte de nómina electrónica",
      "Novedades, ajustes y notas de corrección",
    ],
  },
];

export const CATEGORIES = ["Todos", "NIIF/IFRS", "Tributación", "Auditoría", "Finanzas", "Herramientas Digitales"];

export const PLANS = [
  {
    id: "individual",
    name: "Curso Individual",
    price: 690000,
    installments: 230000,
    tagline: "Para especializarte en un tema puntual",
    features: [
      "1 curso a elección del catálogo",
      "Clases en vivo + grabaciones 12 meses",
      "Material y plantillas descargables",
      "Certificado digital de finalización",
      "Resolución de dudas por WhatsApp",
    ],
    featured: false,
  },
  {
    id: "master",
    name: "Pase Master Trimestral",
    price: 1490000,
    installments: 497000,
    tagline: "La vía rápida para volverte indispensable",
    features: [
      "Acceso a TODOS los cursos por 3 meses",
      "2 mentorías 1:1 con la CP Elena Valenzuela",
      "Simulador de cierre contable con revisión",
      "Comunidad privada de egresados",
      "Bolsa de empleo aliada",
      "Certificación con aval académico",
    ],
    featured: true,
  },
  {
    id: "corporativo",
    name: "Plan Corporativo",
    price: null,
    installments: null,
    tagline: "Capacita a todo tu equipo contable",
    features: [
      "Ruta formativa a la medida de la empresa",
      "Reportes de avance por colaborador",
      "Sesiones privadas en vivo para el equipo",
      "Casos construidos con su propia información",
      "Facturación empresarial",
    ],
    featured: false,
  },
];

export const TESTIMONIALS = [
  {
    name: "Carolina Restrepo",
    role: "Jefe de Contabilidad — Grupo Andino",
    avatar: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&q=80&w=300",
    quote: "Llegué sabiendo registrar y salí sabiendo analizar. El curso de NIIF me dio la confianza para liderar el cierre anual de una multinacional.",
    metric: "+38% aumento salarial",
  },
  {
    name: "Andrés Peñaloza",
    role: "Contador Independiente",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=300",
    quote: "Dupliqué mi cartera de clientes en seis meses. Lo que enseña Elena no está en los libros: es criterio profesional de verdad.",
    metric: "2x clientes en 6 meses",
  },
  {
    name: "María Fernanda Ruiz",
    role: "Analista Financiera — Banca de Inversión",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=300",
    quote: "El módulo de Power BI cambió mi carrera. Mis reportes pasaron de ser ignorados a ser la base de las decisiones del comité.",
    metric: "Ascenso en 8 meses",
  },
  {
    name: "Julián Cárdenas",
    role: "Auxiliar Contable → Contador General",
    avatar: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?auto=format&fit=crop&q=80&w=300",
    quote: "Estudié mientras trabajaba. Las mentorías 1:1 resolvían exactamente lo que enfrentaba cada semana en mi empresa.",
    metric: "De auxiliar a contador general",
  },
];

export const POSTS = [
  {
    id: "reforma-2026",
    title: "Novedades de la Reforma Tributaria 2026: lo que todo contador debe dominar",
    category: "Tributación",
    date: "12 junio 2026",
    readTime: "7 min",
    image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&q=80&w=1200",
    excerpt: "Cambios en tarifas, nuevos límites de deducción y el calendario de implementación que ya deberías tener en tu radar.",
    content: [
      "La reforma tributaria 2026 introduce ajustes estructurales que afectan directamente la planeación fiscal de personas naturales y jurídicas. Los cambios más relevantes se concentran en tres frentes: tarifas del impuesto de renta, límites al sistema de deducciones y nuevas obligaciones de reporte.",
      "En renta de personas naturales, se amplían los rangos de la tabla progresiva y se ajusta el límite conjunto de deducciones y rentas exentas. Esto exige revisar la estrategia de depuración de cada cliente antes del cierre del año gravable, no después.",
      "Para las empresas, el punto crítico está en las nuevas reglas de precios de transferencia simplificados para medianas empresas y en el fortalecimiento del reporte de operaciones con vinculados. La recomendación práctica: documentar desde ahora las políticas de la compañía, porque la carga probatoria recae sobre el contribuyente.",
      "Nuestro consejo es construir un calendario de implementación por trimestre: Q3 para diagnóstico, Q4 para ajustes de políticas y Q1 de 2027 para la primera liquidación bajo las nuevas reglas. Quien se adelanta, convierte la reforma en una oportunidad de asesoría y no en un dolor de cabeza.",
    ],
  },
  {
    id: "cierre-contable",
    title: "Guía paso a paso para un cierre contable anual sin sobresaltos",
    category: "Contabilidad",
    date: "28 mayo 2026",
    readTime: "9 min",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80&w=1200",
    excerpt: "El checklist definitivo: conciliaciones, provisiones, deterioro y revelaciones, en el orden correcto para no rehacer trabajo.",
    content: [
      "Un cierre contable limpio no se logra en diciembre: se construye desde octubre. El primer paso es correr conciliaciones integrales de todas las cuentas de balance — bancos, cartera, proveedores e impuestos — y dejar soportes ajustados antes de que comience la temporada alta de trabajo.",
      "Segundo: revisa las provisiones con juicio técnico. Cartera, inventarios y garantías exigen estimaciones documentadas. La diferencia entre una provisión defendible ante un revisor fiscal y una cifra improvisada está en el soporte metodológico, no en el monto.",
      "Tercero: el test de deterioro de activos. Muchas PYMES lo omiten por desconocimiento, pero las NIIF para PYMES lo exigen cuando hay indicios. Un análisis sencillo de unidades generadoras de efectivo suele ser suficiente para la mayoría de estructuras.",
      "Finalmente, prepara las notas y revelaciones con plantillas del año anterior actualizadas a la normativa vigente. Cierra el ejercicio con una memoria de trabajo que documente juicios, fuentes y decisiones: tu yo del próximo año (y tu revisor fiscal) te lo agradecerán.",
    ],
  },
  {
    id: "excel-a-powerbi",
    title: "Cómo migrar de Excel a Power BI tus reportes NIIF sin morir en el intento",
    category: "Herramientas",
    date: "9 mayo 2026",
    readTime: "6 min",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=1200",
    excerpt: "La ruta pragmática de 4 semanas para dejar los archivos 'final_v23_DEFINITIVO.xlsx' y pasar a reportes vivos.",
    content: [
      "Toda migración exitosa empieza por la higiene de los datos. Antes de abrir Power BI, audita tus archivos de Excel: elimina celdas combinadas, normaliza encabezados y convierte rangos en tablas. El 70% de los fracasos de implementación son problemas de origen, no de herramienta.",
      "La semana dos es de modelado: lleva tu plan de cuentas como tabla de dimensiones y los movimientos como tabla de hechos. Este modelo en estrella, aunque suene técnico, es simplemente separar el 'qué' (cuentas, terceros, centros de costo) del 'cuánto' (saldos y movimientos).",
      "En la semana tres construyes las medidas DAX esenciales: saldo acumulado, variación mensual y porcentaje de ejecución presupuestal. Con cinco medidas bien hechas cubres el 90% de los reportes que la gerencia realmente pide.",
      "Cierra el proceso publicando en el servicio con actualización programada. El resultado: el balance se actualiza solo cada mañana y tu tiempo se libera para el análisis, que es donde un contador aporta valor de verdad.",
    ],
  },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Rigor práctico nivel Big Four",
    text: "Nada de teoría desconectada. Cada norma se enseña con papeles de trabajo, casos y errores reales de auditoría.",
  },
  {
    num: "02",
    title: "Casos reales, en vivo",
    text: "Liquidamos declaraciones, cerramos balances y modelamos reportes en tiempo real, con empresas de verdad.",
  },
  {
    num: "03",
    title: "Mentoría directa",
    text: "Acceso a la CP Elena Valenzuela para resolver los casos que enfrentas esta semana en tu trabajo.",
  },
  {
    num: "04",
    title: "Certificación con aval",
    text: "Certificado verificable que respalda tu perfil ante empleadores y clientes, con registro único por egresado.",
  },
];

export const MARQUEE_ITEMS = [
  "NIIF PYMES 2026",
  "Declaración de Renta",
  "Auditoría Forense",
  "Excel Financiero Avanzado",
  "Control de Gestión",
  "Power BI Contable",
  "Nómina Electrónica",
];
